const COMMON_API = {
	TRANSLATION: '/public/translations',
	USERS_POOLS: '/public/userPools',
	REPORT_JWT_VALIDATION: '/public/downloadReport/jwtValidation',
	DOWNLOAD_REPORT: '/public/downloadReport/url'
};

export default COMMON_API;
